import React from 'react'
import { HeaderAccount } from './headerAccount'
import { HeaderLogo } from './headerLogo'

export const Header = () => {
	return (
		<div className='header'>
			<HeaderLogo />
			<HeaderAccount />
		</div>
	)

}



// WEBPACK FOOTER //
// ./src/components/header.tsx